import { getProjectName } from 'lib/get-project-name'
import { createMediaStyles } from 'lib/styled-helpers'
import styled from 'styled-components'

export type RowProps = {
  flexDirection?: 'column' | 'row' | 'column-reverse' | 'row-reverse'
  justifyContent?: string
  alignItems?: 'flex-start' | 'center' | 'baseline' | 'flex-end'
}

export type ColWidth = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12

export type CellProps = {
  auto?: boolean
  gutters?: boolean
  flexGrow?: number
} & CellSize

// todo: Связать с уже существующим типом брейкпоинтов
export type CellSize = {
  size?: ColWidth
  phablet?: ColWidth
  tablet?: ColWidth
  desktop?: ColWidth
  projectors?: ColWidth
}

export const Container = styled.div`
  position: relative;
  max-width: ${({ theme }) => theme.grid.containerWidth};
  padding: 0 calc(${({ theme }) => theme.grid.containerGutters} / 2);
  display: block;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
`

export const Row = styled.div<RowProps>`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${({ flexDirection }) => (flexDirection ? flexDirection : 'row')};
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: ${({ alignItems }) => (alignItems ? alignItems : 'stretch')};

  margin-left: ${({ theme }) => `calc( -${theme.grid.gutters} / 2) `};
  margin-right: ${({ theme }) => `calc(-${theme.grid.gutters} / 2)`};
`

export const Cell = styled.div<CellProps>`
  flex: 1 0 100%;
  max-width: 100%;
  box-sizing: border-box;
  //Нужно, чтобы контент сжимался
  min-width: 0;
  min-height: 0;

  padding-left: calc(${({ theme }) => theme.grid.gutters} / 2);
  padding-right: calc(${({ theme }) => theme.grid.gutters} / 2);

  ${createMediaStyles(({ size, phablet, tablet, desktop, projectors }) => {
    return {
      phone: size && `flex: 0 0 ${(100 / 12) * size}%;`,
      phablet: phablet && `flex: 0 0 ${(100 / 12) * phablet}%;`,
      tablet: tablet && `flex: 0 0 ${(100 / 12) * tablet}%;`,
      desktop: desktop && `flex: 0 0 ${(100 / 12) * desktop}%;`,
      projectors: projectors && `flex: 0 0 ${(100 / 12) * projectors}%;`
    }
  })}

  ${({ auto }) =>
    auto &&
    `
      flex: 0 0 auto;
      max-width: 100%;
      width: auto;`}

  ${({ gutters, theme }) => gutters && `margin-bottom: ${theme.grid.gutters}`};
  flex-grow: ${({ flexGrow }) => flexGrow};

  ${() =>
    getProjectName() === 'generic_v2' &&
    `
        padding-left: 5px;
        padding-right: 5px;
        margin-bottom: 10px;

        @media (min-width: 768px) {
          padding-left: 10px;
          padding-right: 10px;
          margin-bottom: 20px;
        }
      `}
`
